import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/sections/Hero5.js");
